import React, { useEffect, useState } from "react";
import { Button, Table, Pagination } from "antd";
import { get } from "../../apiService";

import "./AdminViewQuotation.css";
import moment from "moment/moment";
import { FaFilePdf } from "react-icons/fa";
import TitleComp from "./TitleComp";
import { getProfile } from "../../services/localStorageServices";

const AdminViewQuotation = () => {
  const [allquote, setAllQuote] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const { profile } = getProfile();
  const [searchInput, setSearchInput] = useState("");

  const columns = [
    {
      title: "Staff",
      dataIndex: "staff_name",
      key: "staff_name",
    },
    {
      title: "User",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => moment(text).format("llll"),
    },

    {
      title: "View Quotation",
      dataIndex: "quotation_link",
      key: "quotation_link",
      render: (text) => (
        <a target="_blank" href={text} rel="noopener noreferrer">
          <Button className="bg-danger text-white">
            <FaFilePdf /> View
          </Button>
        </a>
      ),
    },
  ];

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize, searchInput);
    }, 300);
    return () => clearTimeout(dbounce);
  }, [searchInput]);

  const fetchData = async (current, pageSize, search) => {
    setLoading(true);
    try {
      const action = "quote";
      const response = await get(
        `/cart.php?limit=${pageSize}&page=${current}&action=${action}${
          profile?.type === "staff" ? "&staff_id=" + profile?.user_id : ""
        }${search ? "&search=" + search + "" : ""}`
      );
      setAllQuote(response.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total, // Assuming the total count is returned in the response
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;

    setPagination({
      ...pagination,
      current,
      pageSize,
    });

    // If pageSize changes, reset to the first page
    if (pageSize !== pagination.pageSize) {
      fetchData(1, pageSize);
    } else {
      fetchData(current, pageSize);
    }
  };

  return (
    <div className="p-3">
      <TitleComp
        name="Quotation List"
        type="Quotation"
        totalData={pagination.total}
        setSearchInput={setSearchInput}
      />
      {/* Table for larger screens */}
      <div className="quotation-table">
        <Table
          columns={columns}
          dataSource={allquote}
          pagination={false}
          loading={loading}
          onChange={handleTableChange}
        />
      </div>

      {/* Cards for smaller screens */}
      <div className="quotation-cards">
        {allquote?.map((quote) => (
          <div className="quotation-card" key={quote.quotation_id}>
            <p>User: {quote.name}</p>
            <p>Staff: {quote.staff_name}</p>
            <p>Message: {quote.message}</p>
            <p>
              Created At:
              {moment(quote.created_at).format("MMMM Do YYYY, h:mm:ss a")}
            </p>

            <Button
              href={quote.quotation_link}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-danger text-white"
            >
              <FaFilePdf /> View Quotation
            </Button>
          </div>
        ))}
      </div>

      {/* Pagination for cards */}
      <div className="quotation-pagination mt-4">
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          onChange={(page, pageSize) =>
            handleTableChange({ current: page, pageSize })
          }
        />
      </div>
    </div>
  );
};

export default AdminViewQuotation;

